import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { ErrorMessage } from './ErrorMessage';
import errorImg from '@assets/icons/error.svg';

export const useStyles = makeStyles<Theme>({
  wrapper: { padding: 30, textAlign: 'center' },
  image: { height: 60 },
});

export interface Props {
  error: Error;
  helpMsg?: string;
}

export const ErrorContent: React.FC<Props> = ({ error, helpMsg }) => {
  const { wrapper, image } = useStyles();

  return (
    <div className={wrapper}>
      <img src={errorImg} alt='Empty' className={image} />

      <Typography color='inherit' align='center' component='div'>
        <Typography color='inherit' variant='h5' gutterBottom>
          Error
        </Typography>

        {helpMsg && <Typography color='inherit'>{helpMsg}</Typography>}

        <Typography color='inherit' component='div'>
          <ErrorMessage error={error} showStack={process.env.NODE_ENV === 'development'} />
        </Typography>
      </Typography>
    </div>
  );
};
